import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { Component } from 'react';
import { inputClass } from './styles';

var Clear =
/*#__PURE__*/
function (_Component) {
  _inherits(Clear, _Component);

  var _super = _createSuper2(Clear);

  function Clear(props) {
    var _this;

    _classCallCheck(this, Clear);

    _this = _super.call(this, props);
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Clear, [{
    key: "handleClick",
    value: function handleClick(e) {
      // do not blur
      e.preventDefault();
      var _this$props = this.props,
          onClick = _this$props.onClick,
          clearResult = _this$props.clearResult;
      if (onClick) onClick({
        target: {
          value: clearResult
        }
      }, true);
    }
  }, {
    key: "render",
    value: function render() {
      return (
        /*#__PURE__*/
        React.createElement("div", {
          onMouseDown: this.handleClick,
          className: inputClass('clear-wrapper')
        },
        /*#__PURE__*/
        React.createElement("div", {
          className: inputClass('clear')
        }))
      );
    }
  }]);

  return Clear;
}(Component);

export default Clear;